module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      key: index,
      class: [
        item.team ? (item.team.includes(_vm.user.team_id) ? '' : 'hidden') : '',
        item.t_session ?
        item.t_session.includes(_vm.session_team_current) ?
        '' :
        'hidden' :
        '' ]
    }, [(item.role.includes(_vm.user.role)) ? _c('router-link', {
      class: [
        _vm.classname,
        _vm.subIsActive(item.to) ? (_vm.classname + "--active") : '' ],
      attrs: {
        "to": item.to
      }
    }, [_c('div', {
      class: (_vm.classname + "__icon")
    }, [_c('app-icon', {
      attrs: {
        "name": item.icon
      }
    })], 1), _vm._v(" "), _c('div', {
      class: (_vm.classname + "__title")
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])]) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6b1f44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/partials/SideBar.vue
// module id = 445
// module chunks = 1